import sheetKeys from "./sheetKeys"

export const allInvaders = [
    sheetKeys.alien1 ,
    sheetKeys.alien2 ,
    sheetKeys.alien3 ,
    sheetKeys.battleShip ,
    sheetKeys.BlockadeRunner ,
    sheetKeys.crawler ,
    sheetKeys.delta ,
    sheetKeys.drones ,
    sheetKeys.dualGun ,
    sheetKeys.fighter ,
    sheetKeys.graviton ,
    sheetKeys.gunner ,
    sheetKeys.meteorLike ,
    sheetKeys.particleGreen ,
    sheetKeys.projectile2 ,
    sheetKeys.projectile3 ,
    sheetKeys.racer ,
    sheetKeys.rower ,
    sheetKeys.shileld ,
    sheetKeys.speeder ,
    sheetKeys.supporter ,
    sheetKeys.tieTransporter ,
    sheetKeys.transporter ,
    sheetKeys.zorak ,    
  ]

  export const allShape = [
    sheetKeys.alien1,
    sheetKeys.alien2,
    sheetKeys.alien3,
    sheetKeys.battleShip,
    sheetKeys.bigCross,
    sheetKeys.bigGunTower,
    sheetKeys.block,
    sheetKeys.BlockadeRunner,
    sheetKeys.blueSun,
    sheetKeys.buildings,
    sheetKeys.button,
    sheetKeys.city,
    sheetKeys.crawler,
    sheetKeys.delta,
    sheetKeys.drones,
    sheetKeys.dualGun,
    sheetKeys.fighter,
    sheetKeys.globe,
    sheetKeys.graviton,
    sheetKeys.gunner,
    sheetKeys.gunTower,
    sheetKeys.manta,
    sheetKeys.meteorLike,
    sheetKeys.moon,
    sheetKeys.nebulaInspector,
    sheetKeys.obstacle,
    sheetKeys.offBase,
    sheetKeys.partickleViolet,
    sheetKeys.particleGreen,
    sheetKeys.piece,
    sheetKeys.projectile2,
    sheetKeys.projectile3,
    sheetKeys.racer,
    sheetKeys.redBlock,
    sheetKeys.rocket,
    sheetKeys.rower,
    sheetKeys.shileld,
    sheetKeys.smallMoon,
    sheetKeys.speeder,
    sheetKeys.supporter,
    sheetKeys.tieTransporter,
    sheetKeys.transporter,
    sheetKeys.whiteSun,
    sheetKeys.yellowSun,
    sheetKeys.zorak,
  ];

  export const enviroment = [
    sheetKeys.alien1,
    sheetKeys.alien2,
    sheetKeys.alien3,
    sheetKeys.battleShip,
    sheetKeys.bigCross,
    sheetKeys.bigGunTower,
    sheetKeys.block,
    sheetKeys.BlockadeRunner,
    sheetKeys.buildings,
    sheetKeys.city,
    sheetKeys.crawler,
    sheetKeys.delta,
    sheetKeys.dualGun,
    sheetKeys.globe,
    sheetKeys.graviton,
    sheetKeys.gunner,
    sheetKeys.gunTower,
    sheetKeys.meteorLike,
    sheetKeys.obstacle,
    sheetKeys.offBase,
    sheetKeys.piece,
    sheetKeys.racer,
    sheetKeys.redBlock,
    sheetKeys.rower,
    sheetKeys.speeder,
    sheetKeys.supporter,
    sheetKeys.tieTransporter,
    sheetKeys.transporter,
    sheetKeys.zorak,
  ];